import { type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { rem } from "polished";

export const DatePickerButtonStyle = (
  error?: boolean,
  value?: Date | null,
  sx?: SxProps<Theme>
): SxProps<Theme> => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  textTransform: "none",
  border: "1px solid",
  padding: `${rem(16.5)} ${rem(9)}`,
  lineHeight: rem(17),
  borderColor: error ? "error.main" : "rgba(0, 0, 0, 0.23)",
  borderRadius: 1,
  backgroundColor: "background.paper",
  fontWeight: 400,
  color: value ? "datePicker.text" : "datePicker.placeholder",
  "&:hover": {
    borderColor: error ? "error.main" : "text.primary",
    backgroundColor: "background.paper",
  },
  "&:focus": {
    borderColor: error ? "error.main" : "primary.main",
    borderWidth: "2px",
    outline: "none",
  },
  ...sx,
});
